import React, { useEffect } from 'react';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { MarqueeBanner } from '../components/MarqueeBanner';
import { HeroSection } from '../components/HeroSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { AlumnosSection } from '../components/AlumnosSection';
import { CourseContentSection } from '../components/CourseContentSection';
import { TestimonialsBanner } from '../components/TestimonialsBanner';
import { TestimonialsFeatures } from '../components/TestimonialsFeatures';
import { BonusSection } from '../components/BonusSection';
import { FAQ2Section } from '../components/FAQ2Section';
import { TestimonialsMasonrySection } from '../components/TestimonialsMasonrySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  useEffect(() => {
    document.title = 'Emprende Digital';
  }, []);
  return <main className="w-full min-h-screen bg-brand-bg" data-id="element-310">
      <MarqueeBanner data-id="element-311" />
      <UrgencyBanner data-id="element-312" />
      <HeroSection data-id="element-313" />
      <CaseStudySection data-id="element-314" />
      <PricingSection data-id="element-315" />

      <AlumnosSection data-id="element-316" />
      <CourseContentSection data-id="element-317" />
      <TestimonialsBanner data-id="element-318" />
      <TestimonialsFeatures data-id="element-319" />
      <BonusSection data-id="element-320" />
      <TestimonialsSection data-id="element-321" />
      <TestimonialsMasonrySection data-id="element-322" />
      <FAQ2Section data-id="element-323" />
      <FinalCTASection data-id="element-324" />
    </main>;
}